import type { JSX } from "react";
import type { MembershipDTO, TenantDTO } from "../api/types.js";

/**
 * Auswahl des Mandanten. Ein Benutzer kann zu mehreren Unternehmen gehören —
 * etwa als externer Dienstleister.
 *
 * Auf Testsystemen stehen Internen auch Mandanten offen, in denen sie gar nicht
 * Mitglied sind. Die sind kenntlich gemacht: wer dort etwas ändert, soll wissen,
 * dass er in fremden Daten arbeitet.
 */
export function TenantSwitcher({
  memberships,
  activeTenant,
  onSelect,
  busy,
}: {
  memberships: MembershipDTO[];
  activeTenant: TenantDTO | null;
  onSelect: (slug: string) => void;
  busy: boolean;
}): JSX.Element | null {
  if (memberships.length === 0) {
    return null;
  }

  if (memberships.length === 1) {
    return <span className="max-w-24 truncate text-sm font-medium text-ink sm:max-w-48">{activeTenant?.name ?? ""}</span>;
  }

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">Mandant</span>
      <select
        value={activeTenant?.slug ?? ""}
        disabled={busy}
        title={busy ? "Mandant wird gewechselt" : "Mandant wechseln"}
        onChange={(event) => onSelect(event.target.value)}
        className="max-w-[12rem] truncate rounded-lg border border-line bg-surface px-2 py-1.5 text-ink disabled:opacity-60"
      >
        {activeTenant === null ? <option value="">Bitte wählen</option> : null}
        {memberships.map((membership) => (
          <option key={membership.id} value={membership.tenant.slug}>
            {membership.viaInternal ? `${membership.tenant.name} (intern)` : membership.tenant.name}
          </option>
        ))}
      </select>
    </label>
  );
}
